import * as Yup from 'yup';

export const numberFieldValidator = Yup.number().typeError('Must be a postive number').min(0, 'Must be greater than or equal to 0');

/**
 * Validator for number fields that are able to be empty
 * The value is only treated as a number if it's not empty
 */
export const optionalNumberFieldValidator = Yup.lazy(value => (value === '' ? Yup.string().optional() : numberFieldValidator.optional()));

export const requiredNumberFieldValidator = numberFieldValidator.required('Field is required');
